import { render, staticRenderFns } from "./AdvertisementUp.vue?vue&type=template&id=718bf96c&scoped=true&lang=pug&"
import script from "./AdvertisementUp.vue?vue&type=script&lang=js&"
export * from "./AdvertisementUp.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementUp.vue?vue&type=style&index=0&id=718bf96c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bf96c",
  null
  
)

export default component.exports